import React from "react";
import { Link } from "gatsby-plugin-react-i18next";

import user1 from "../../assets/images/user1.jpg";
import user2 from "../../assets/images/user2.jpg";
import user3 from "../../assets/images/user3.jpg";
import logo_mentoree from "../../assets/images/logo_mentoree.jpg";
import StarIcon from "../../assets/images/star-icon.png";

const EcoCard = () => {
	return (
		<div className="blog-area pt-100px pb-70">
			<div className="container">
				<div className="pb-100">
					<div className="how-its-work-content m-0">
						<span className="sub-title">
							<img src={StarIcon} alt="Blog" />
							VOS PARTENAIRES POUR DÉCROCHER VOTRE PROCHAIN POSTE
						</span>
						<h2>
							Bénéficier de nos expériences métier et de notre
							connaissance du processus de recrutement.
						</h2>
						<p>
							Nos partners vous proposent divers programme et
							solutions d’accompagnement. De la mise en avant de
							vos compétences et de votre comportement
							professionnel, à la préparation de votre entretien,
							à l’identification et la prospection des
							entreprises.
						</p>
					</div>
				</div>
		 
				<div className="row">
					<div className="col-lg-4 col-md-6">
						<div className="single-blog-post bg-fffbf5">
							<div className="post-image">
								<Link to="https://vocationpodcast.substack.com/">
									<img
										src="https://substackcdn.com/image/fetch/w_1272,c_limit,f_webp,q_auto:best,fl_progressive:steep/https%3A%2F%2Fbucketeer-e05bbc84-baa3-437e-9518-adb32be77984.s3.amazonaws.com%2Fpublic%2Fimages%2Fa8f10421-773d-49ca-9755-b826aa2b8cf3_1279x478.png"
										alt="Vocation"
										id="logo"
										data-height-percentage="63"
										data-actual-width="446"
										data-actual-height="167"
									/>{" "}
								</Link>
							</div>

							<div className="post-content">
								<ul className="post-meta d-flex justify-content-between align-items-center">
									<li>
										<div className="post-author d-flex align-items-center">
											<img
												src={user2}
												className="rounded-circle"
												alt="Blog"
											/>
											<span>Jasmine et Carla</span>
										</div>
									</li>
									<li>
										<i className="flaticon-calendar"></i>{" "}
										Mars 13, 2021
									</li>
								</ul>
								<h3>
									<Link to="/eco-services-voc">
										Le média de ceux qui cherchent la
										réponse à leurs questions sur le monde
										pro, en toute transparence et sans
										jugement.
									</Link>
								</h3>
							</div>
						</div>
					</div>

					<div className="col-lg-4 col-md-6">
						<div className="single-blog-post bg-fffbf5">
							<div className="post-image">
								<Link to="https://www.goodriders.co/">
									<img
										src="https://static.wixstatic.com/media/e1b574_fbd46361298144ff8592663dcbb51128~mv2.png/v1/fill/w_353,h_134,al_c,q_85,usm_0.66_1.00_0.01/logo%203.webp"
										alt="Logo"
										class="publication-logo"
									/>
								</Link>
							</div>

							<div className="post-content">
								<ul className="post-meta d-flex justify-content-between align-items-center">
									<li>
										<div className="post-author d-flex align-items-center">
											<img
												src={user1}
												className="rounded-circle"
												alt="Blog"
											/>
											<span>Guilhem</span>
										</div>
									</li>
									<li>
										<i className="flaticon-calendar"></i>{" "}
										Mars 15, 2022
									</li>
								</ul>
								<h3>
									<Link to="/eco-services-good">
										Goodriders te permet d'apporter tes
										compétences à des projets à impact
										positif, en fonction de tes dispos.
									</Link>
								</h3>
							</div>
						</div>
					</div>

					<div className="col-lg-4 col-md-6">
						<div className="single-blog-post bg-fffbf5">
							<div className="post-image">
								<Link to="https://www.mentoree.eu">
									<img
										src={logo_mentoree}
										alt="Blog"
										className="rounded-circle"
									/>
								</Link>
							</div>

							<div className="post-content">
								<ul className="post-meta d-flex justify-content-between align-items-center">
									<li>
										<div className="post-author d-flex align-items-center">
											<img
												src={user3}
												className="rounded-circle"
												alt="Blog"
											/>
											<span>Francois </span>
										</div>
									</li>
									<li>
										<i className="flaticon-calendar"></i>{" "}
										June 2, 2022
									</li>
								</ul>
								<h3>
									<Link to="/eco-services-mentoree">
										la première plateforme révélant comment
										réussir un entretien d’embauche ou
										devenir entrepreneur à l’aide de
										conseils et ressources de mentorat.
									</Link>
								</h3>
							</div>
						</div>
					</div>

					<div className="col-lg-12 col-md-12">
						{/* Pagination */}

						{/*
                        <div className="pagination-area text-center">
                            <Link to="#" className="prev page-numbers">
                                <i className='bx bx-chevrons-left'></i>
                            </Link>
                            <span className="page-numbers current" aria-current="page">1</span>
                            <Link to="#" className="page-numbers">
                                2
                            </Link>
                            <Link to="#" className="page-numbers">
                                3
                            </Link>
                            <Link to="#" className="page-numbers">
                                4
                            </Link>
                            <Link to="#" className="next page-numbers">
                                <i className='bx bx-chevrons-right'></i>
                            </Link>
                        </div>
                    </div>
                    */}
					</div>
				</div>
			</div>
		</div>
	);
};

export default EcoCard;
